import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Screener } from '../_models/Screener';
import { Observable } from 'rxjs';
import { APP_CONFIG } from '../lib/angular/injection-tokens';
import { IAppConfig } from '../lib/config/app-config';

@Injectable({
  providedIn: 'root',
})
export class ScreenerService {
  private baseUrl: string = this.config.publicBaseUrl;
  private static readonly path: string = 'PublicScreener/';

  constructor(private http: HttpClient, @Inject(APP_CONFIG) private config: IAppConfig) {}

  addScreener$(screener: Screener) : Observable<Screener> {
    return this.http.post<Screener>(this.baseUrl + ScreenerService.path, screener);
  }
}
